import { Button, Col, Menu, Row, Drawer, Image } from "antd";
import {
  UserAddOutlined,
  MenuFoldOutlined,
  LoginOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { getURL, images_folder } from "./client";
import { useState } from "react";

const MainMenu = (props) => {
  const [openMenu, setOpenMenu] = useState(false);
  const onMenuClose = () => {
    setOpenMenu(!openMenu);
  };
  const headerTypes = {
    "create-account": (
      <>
        <Link to={getURL("/")} className="hide-mobile">
          <Button icon={<LoginOutlined />} size="medium">
            Sign In
          </Button>
        </Link>
        <Button
          onClick={onMenuClose}
          className="hide-large"
          icon={<MenuFoldOutlined />}
        >
          {" "}
          Menu
        </Button>
      </>
    ),

    "logged-out": (
      <>
        <Link className="hide-mobile" to={getURL("/create-account")}>
          <Button icon={<UserAddOutlined />} size="medium">
            Create New Account
          </Button>
        </Link>
        <Button
          onClick={onMenuClose}
          className="hide-large"
          icon={<MenuFoldOutlined />}
        >
          {" "}
          Menu
        </Button>
      </>
    ),

    "logged-in": (
      <Link to={getURL("/create-account")}>
        <Button icon={<UserAddOutlined />} size="medium">
          Create New Account
        </Button>
      </Link>
    ),
  };

  const items = [
    /*{
            label: 'About Us',
            key: 'SubMenu',
        },
        {
            label: 'How to Apply',
            key: 'apply',
        },
        {
            label: 'FAQ',
            key: 'about',
        },
        {
            label: 'Contact Us',
            key: 'contact',
        },*/
  ];
  return (
    <>
      <Drawer title="" placement="right" onClose={onMenuClose} open={openMenu}>
        <br />
        <Link to={getURL("/")}>
          <Button block icon={<LoginOutlined />} size="medium">
            Sign In
          </Button>
        </Link>
        <br />
        <br />
        <hr />
        <Menu className="main-menu" mode="inline" items={items} />
      </Drawer>
      <Row>
        <Image
          width={50}
          preview={false}
          src={images_folder("princess-obome-helping-hand-logo.png")}
        />
        <h3 style={{ margin: "0", paddingLeft: "10px" }}>
          Princess Obome Foundation
        </h3>
        <Col flex="auto">
          <Menu
            className="main-menu hide-mobile"
            mode="horizontal"
            items={items}
          />
        </Col>
        <Col flex="0">{headerTypes[props.headerType]}</Col>
      </Row>
    </>
  );
};

export default MainMenu;
